import React from "react";
import pure from "js/common/views/pure";

export default pure(({style}) => <i className="fa fa-arrow-right" style={{fontSize: "0.875rem", ...style}} />);
